import { ModalCustom } from "components/ModalCustom";
import { PrimaryButton } from "components/Button/style";
import { FaExclamationTriangle } from "react-icons/fa";
import styled from "styled-components";

interface Props {
  show: boolean;
  handleClose: () => void;
  onConfirmar: () => void;
  idProcesso?: number;
  loading?: boolean;
}

const IconeContainer = styled.div`
  padding: 0.75rem 1rem;
  background-color: #fff8e1;
  border-radius: 0.5rem;
  svg {
    color: #f0a500;
  }
`;

const InfoContainer = styled.div`
  display: grid;
  place-items: center;
  gap: 1rem;
  padding: 1rem;
`;

export function ModalConfirmarReprocessarEscolherPlaca({
  show,
  handleClose,
  onConfirmar,
  idProcesso,
  loading,
}: Props) {
  return (
    <ModalCustom
      show={show}
      handleClose={handleClose}
      title="Reprocessar - Escolher placa"
      centered
      adaptive
    >
      <InfoContainer>
        <IconeContainer>
          <FaExclamationTriangle size={24} />
        </IconeContainer>
        <div style={{ textAlign: "center" }}>
          {!!idProcesso && (
            <span style={{ display: "block", fontWeight: 600, marginBottom: 4 }}>
              ID Processo: {idProcesso}
            </span>
          )}
          <span>
            Esta etapa já foi concluída. Deseja executar a escolha de placa novamente?
          </span>
        </div>
      </InfoContainer>
      <div className="d-flex justify-content-end gap-4 mt-4">
        <PrimaryButton
          style={{ width: "10rem" }}
          outline
          variante="primary"
          onClick={handleClose}
          disabled={loading}
        >
          Cancelar
        </PrimaryButton>
        <PrimaryButton
          style={{ width: "10rem" }}
          onClick={onConfirmar}
          disabled={loading}
        >
          Reprocessar
        </PrimaryButton>
      </div>
    </ModalCustom>
  );
}
